import img from '../sc-01.png';

export default {
	title: 'VTBB',
	content: `
		VTBB is Vibert Thio's amazingly adorable babyyyyyyyyy,
		a cute little audio/visual game built with Processing.
    `,
	links: [
		{
			name: 'Showcase Video',
			url: 'https://vimeo.com/184943616',
		},
		{
			name: 'Source Code',
			url: 'https://github.com/vibertthio/VTBB',
		},
	],
	img,
};



// WEBPACK FOOTER //
// ./src/pages/projects/vtbb/desc/index.js